import { render, staticRenderFns } from "./learningMaterialsUK.vue?vue&type=template&id=44d7337d&scoped=true"
import script from "./learningMaterialsUK.vue?vue&type=script&lang=js"
export * from "./learningMaterialsUK.vue?vue&type=script&lang=js"
import style0 from "./learningMaterialsUK.vue?vue&type=style&index=0&id=44d7337d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d7337d",
  null
  
)

export default component.exports